<template>
  <div class="feedback-modal-dialog">
    <MobilePopup
      v-if="isMobile"
      v-model:visible="internalVisible"
      title="意见反馈"
      :show-confirm="false"
      :show-cancel="false"
      height="650px"
      panel-class="feedback-modal-dialog__mobile-drawer"
      @close="handleRequestClose"
    >
      <div class="feedback-modal-dialog__drawer-body">
        <FeedbackModalContent
          ref="contentRef"
          :show-actions="false"
          select-popup-container=".feedback-modal-dialog__mobile-drawer"
          @submitted="handleSubmitted"
        />
      </div>

      <template #footer>
        <AButton
          type="primary"
          class="feedback-modal-dialog__submit-btn"
          :loading="submitting"
          @click="handleMobileSubmit"
        >
          提交
        </AButton>
      </template>
    </MobilePopup>

    <InfoPanelModal
      v-else
      v-model:visible="internalVisible"
      title="意见反馈"
      ok-text="提交"
      ok-type="primary"
      :show-cancel="false"
      :show-ok="true"
      :width="600"
      :ok-loading="submitting"
      :ok-disabled="submitDisabled"
      :before-ok="handlePanelBeforeOk"
      panel-class="feedback-info-panel"
      @close="handleRequestClose"
    >
      <FeedbackModalContent ref="contentRef" :show-actions="false" @submitted="handleSubmitted" />
    </InfoPanelModal>
  </div>
</template>

<script setup>
/**
 * @description 意见反馈弹窗容器，移动端复用底部弹窗，PC 端复用信息面板弹窗
 * @param {boolean} visible - 是否显示弹窗
 * @emits update:visible - 更新弹窗显示状态
 * @emits submitted - 反馈提交成功
 * @emits close - 弹窗关闭
 */

import { Button as AButton } from '@arco-design/web-vue'
import { computed, ref } from 'vue'
import FeedbackModalContent from '~/components/base/FeedbackModalContent.vue'
import InfoPanelModal from '~/components/base/InfoPanelModal.vue'
import MobilePopup from '~/components/mobile/Popup.vue'
import { useMediaQuery } from '~/composables/useMediaQuery'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:visible', 'submitted', 'close'])

const { isMobile } = useMediaQuery()
const contentRef = ref(null)

const internalVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
})

const getExposedValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value
  }
  return value
}

const submitting = computed(() => {
  return Boolean(getExposedValue(contentRef.value?.isSubmitting))
})

const submitDisabled = computed(() => {
  return !getExposedValue(contentRef.value?.isFormValid)
})

const handleRequestClose = () => {
  emit('close')
}

const handleClose = () => {
  internalVisible.value = false
}

const handleSubmitted = () => {
  emit('submitted')
  handleClose()
}

const handleMobileSubmit = async () => {
  await contentRef.value?.submit?.()
}

const handlePanelBeforeOk = async () => {
  await contentRef.value?.submit?.()
  return false
}
</script>

<style lang="scss" scoped>
.feedback-modal-dialog {
  &__drawer-body {
    min-height: 100%;
    background-color: $bg-white;
    padding: 0;
  }

  &__submit-btn {
    width: 100%;
    height: 44px;
    border-radius: 4px;
    background-color: $primary-color;
    border: none;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
